<template>
  <div class="container-fluid mycontainer-fluid content">
    <br />
    <a @click="$parent.hidePlan()">&#x025c2; Вернуться к документам</a>
    <br />
    <br />
    <!--<div class="content-title content-mb-14">
      21. Состав оборудования в проекте, планируемого к приобретению за счет
      средств займа
    </div>
    <EquipmentZaim></EquipmentZaim>-->

    <div class="content-title content-mb-14">
      1. Состав оснастки в проекте, планируемой к приобретению за счет займа
    </div>
    <EquipmentRigging></EquipmentRigging>
  </div>
</template>

<script>
import { ProjectsService } from "@/common/api.service";
import UFDopInfo from "@/components/project/form/partial/UFDopInfo";
import EquipmentZaim from "@/components/project/form/partial/EquipmentZaim";
import EquipmentLicensesPatents from "@/components/project/form/partial/EquipmentLicensesPatents";
import EquipmentRigging from "@/components/project/form/partial/EquipmentRigging";
export default {
  name: "step7component_and_resource_base",
  components: {
    EquipmentRigging,
    EquipmentLicensesPatents,
    EquipmentZaim,
    UFDopInfo
  },
  props: ["step", "project"],

  data() {
    return {
      siteUrl: "",
      FILE_DOCUMENTS_PATH: [],
      showDD: true
    };
  },
  mounted() {
    this.getDocInfo();
  },
  methods: {
    getFileName(file) {
      let p = file.split("/");
      return p[p.length - 1];
    },
    getDocInfo() {
      ProjectsService.getDocumentESProjects(2845).then(({ data }) => {
        data.FILE_DOCUMENTS_PATH[14373]
          ? (this.FILE_DOCUMENTS_PATH = data.FILE_DOCUMENTS_PATH[14373])
          : (this.showDD = false);
      }, this);
    }
  }
};
</script>

<style scoped></style>
